// /* eslint-disable no-nested-ternary */
import { useEffect, useState, useRef } from 'react';
import ReactPlayer from 'react-player';

import { ArrowBack, ArrowForward } from '@mui/icons-material';
import { IconButton, LinearProgress } from '@mui/material';

import PropTypes from 'prop-types';
import _ from 'lodash';
import { FadeInAnimation, Image } from '../shared';
import useResponsive from '../../../utils/responsive';
import Carousel from '../carousel/carousel.component';
import { render } from 'nprogress';

const GalleryCarouselMobile = (props) => {

    const { data, category, inDialog, selectedMedia, selectedIndex } = props;

    const dataLength = _.size(data);

    const getScreenWidth = (referenceWidth) => {
        return window.innerWidth <= referenceWidth ? referenceWidth : 1920;
    };      

    const carouselRef = useRef();

    const [currentCardIndex, setCurrentCardIndex] = useState(0);
    const [transformValue, setTransformValue] = useState(0);
    const [cardWidth, setCardWidth] = useState(getScreenWidth(412));
    const [currentSlideNumber, setCurrentSlideNumber] = useState(1);

    useEffect(() => {
        const handleResize = () => {
            setCardWidth(getScreenWidth(1366));
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {        
        if (!carouselRef.current) return;

        const container = carouselRef.current;
        const activeCard = container.querySelectorAll('.gallery-carousel-mobile-slide')[currentCardIndex];
        if (!activeCard) return;

        const containerWidth = container.parentElement.offsetWidth;
        const cardRect = activeCard.getBoundingClientRect();
        const containerRect = container.getBoundingClientRect();
        
        
        const cardCenter = cardRect.left + cardRect.width / 2;
        const containerCenter = containerRect.left + containerWidth / 2;

        setTransformValue(containerCenter - cardCenter);       
        
    }, [currentCardIndex, cardWidth]);  

    const goToNextCard = () => {
        if (currentCardIndex < dataLength - 1) {
            const newIndex = currentCardIndex + 1;
            setCurrentCardIndex(newIndex);
            const number = currentSlideNumber < dataLength ? currentSlideNumber + 1 : dataLength;
            setCurrentSlideNumber(number);
        } else {            
            setCurrentCardIndex(0); 
            setCurrentSlideNumber(1);
        }
    };

    const goToPreviousCard = () => {        
        if (currentCardIndex > 0) {
            const newIndex = currentCardIndex - 1;
            const number = currentSlideNumber <= dataLength ? currentSlideNumber - 1 : 1;
            setCurrentSlideNumber(number);
            setCurrentCardIndex(newIndex);
        } else {
            const number = dataLength;
            setCurrentSlideNumber(number);
            const newIndex = dataLength - 1;
            setCurrentCardIndex(newIndex);
        }
    };    

    const trackWidth = `${dataLength * 100}%`;
    const wrapperWidth = `${(100 / dataLength).toFixed(5)}%`;      

    const renderCarousel = () => {
        return (
            <>
                <div className="gallery-carousel-mobile-header-container">
                    <h3>Our Gallery</h3>
                </div>
                <div className='gallery-carousel-mobile'>
                    <div className='gallery-carousel-mobile-reveal'>
                        <div className='gallery-carousel-mobile-carousel'>
                            <div className='gallery-carousel-mobile-slider'>
                                <div className='gallery-carousel-mobile-slider-tray-wrap'>
                                    <ul ref={carouselRef} 
                                        style={{ width: trackWidth, transform: `translate3d(${transformValue}px, 0px, 0px)` }}
                                        className='gallery-carousel-mobile-slider-tray'>
                                        {_.map(data, (item, index) => {
                                            const image = _.get(item, 'media_items_image.url');
                                            const caption = _.get(item, 'media_items_caption');
                                            const tag = _.get(item, 'medai_items_tag');
                                            const video = _.get(item, 'media_items_video_src');
                                            return (
                                                <div className="gallery-carousel-mobile-slider-wrapper" key={index}>
                                                    <li style={{ width: wrapperWidth, paddingBottom: '4.2%' }} className='gallery-carousel-mobile-slide'>
                                                        <div className='gallery-carousel-mobile-slider-inner'>
                                                            <div className='gallery-carousel-mobile-image-container'>
                                                                {image ? (
                                                                    <Image 
                                                                        src={image} 
                                                                        alt={caption || 'gallery-item'} 
                                                                        width="100%" 
                                                                        height="80%" 
                                                                        id={`${image}-carousel-button`}
                                                                        isContainerButton
                                                                        isOldImage
                                                                        className='gallery-carousel-mobile-carousel-image'
                                                                    />
                                                                ): (
                                                                    <ReactPlayer url={video} width="100%" height="80%" playing={selectedMedia && selectedMedia.media === video} controls />
                                                                )} 
                                                                
                                                            </div>
                                                        </div>
                                                        <p className='gallery-carousel-mobile-tag'>
                                                            {_.toUpper(tag)}
                                                        </p>
                                                    </li>
                                                </div>
                                            );
                                        })}
                                    </ul>
                                </div>
                            </div>
                        </div>                
                    </div>
                    <div className="gallery-carousel-button-container">
                        <div className="gallery-carousel-button-container-counter">
                            <h6 className="gallery-carousel-counter">{currentSlideNumber}/{dataLength}</h6>
                        </div>
                        <div className="gallery-carousel-button-container-buttons">
                            <div className="gallery-carousel-button-container-pagination">
                                <button type="button" aria-label="Back"
                                    className="gallery-carousel-button gallery-carousel-button-back"
                                    onClick={goToPreviousCard}
                                    role="button" aria-disabled="false" id="gallery-carousel-button-back" right="14">
                                    <span
                                        className="gallery-carousel-label">
                                        <svg
                                            className="gallery-carousel-icon-root"
                                            focusable="false" viewBox="0 0 24 24" aria-hidden="true">
                                            <path
                                                d="M19 11H7.83l4.88-4.88c.39-.39.39-1.03 0-1.42a.9959.9959 0 00-1.41 0l-6.59 6.59c-.39.39-.39 1.02 0 1.41l6.59 6.59c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L7.83 13H19c.55 0 1-.45 1-1s-.45-1-1-1z">
                                            </path>
                                        </svg>
                                    </span>
                                    <span className="gallery-carousel-ripple-root"></span>
                                </button>
                                <button type="button" aria-label="Next"
                                    className="gallery-carousel-button gallery-carousel-button-next"
                                    onClick={goToNextCard}
                                    role="button" aria-disabled="false" id="gallery-carousel-button-next" right="11">
                                    <span
                                        className="gallery-carousel-label">
                                        <svg
                                            className="gallery-carousel-icon-root"
                                            focusable="false" viewBox="0 0 24 24" aria-hidden="true">
                                            <path
                                                d="M5 13h11.17l-4.88 4.88c-.39.39-.39 1.03 0 1.42.39.39 1.02.39 1.41 0l6.59-6.59c.39-.39.39-1.02 0-1.41l-6.58-6.6a.9959.9959 0 00-1.41 0c-.39.39-.39 1.02 0 1.41L16.17 11H5c-.55 0-1 .45-1 1s.45 1 1 1z">
                                            </path>
                                        </svg>
                                    </span>
                                    <span className="gallery-carousel-ripple-root"></span>
                                </button>
                            </div>

                        </div>

                    </div>                      
                </div>
            </>
        )
    };

    return renderCarousel();

};

export default GalleryCarouselMobile;

GalleryCarouselMobile.propTypes = {
    data: PropTypes.array,
    title: PropTypes.string,
    inDialog: PropTypes.bool,
    selectedMedia: PropTypes.object,
    selectedIndex: PropTypes.number,
};

